import { reducer, actions as jobSearchModuleActions, selectors } from './jobSearchModule'
import { sagaActions } from './jobSearchSagas'
export { sagas } from './jobSearchSagas'

const actions = {
  ...jobSearchModuleActions,
  ...sagaActions,
}
export { reducer, selectors, actions }
